module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-38.fefe010b.png";